module.exports = __webpack_public_path__ + "static/media/gem.27f6f972.png";